export default ($) => {
    const hasFocusClass = 'jsUpload--HasFocus';
    const hasFileClass = 'jsUpload--HasFile';

    const getFileName = (input, changeEvent) => {
        if (input.files && input.files.length > 1) {
            return (input.getAttribute('data-multiple-caption') || '').replace('{count}', input.files.length);
        } else if (changeEvent.target.value) {
            return changeEvent.target.value.split('\\').pop();
        } else {
            return '';
        }
    };

    const initializeUploader = (uploader) => {
        // uploader is the container and must contains:
        // 1) an input[type=file] item
        // 2) a [data-field-upload-placeholder] item
        // 3) a [data-field-upload-file] item
        const input = $('input[type=file]', uploader);
        const placeholder = $('[data-field-upload-placeholder]', uploader);
        const file = $('[data-field-upload-file]', uploader);

        if (input.length === 0) {
            console.error('Missing the input[type=file] element for the uploader', uploader);
            return;
        }

        if (placeholder.length === 0) {
            console.error('Missing the placeholder element for the uploader', uploader);
            return;
        }

        if (file.length === 0) {
            console.error('Missing the file name element for the uploader', uploader);
            return;
        }

        // when the file is added...
        input.on('change', function (e) {
            const fileName = getFileName(input.get(0), e);
            file.html(fileName);
            
            if (fileName) {
                uploader.addClass(hasFileClass);
            } else {
                uploader.removeClass(hasFileClass);
            }
        });

        // Firefox bug fix
        input.on('focus', function () {
            uploader.addClass(hasFocusClass);
        });

        input.on('blur', function () {
            uploader.removeClass(hasFocusClass);
        });
    };

    document.arrive('[data-field-upload]', {existing: true}, function () {
      initializeUploader($(this));
    });
}



// WEBPACK FOOTER //
// ./assets/js/component/upload.js